import { render, staticRenderFns } from "./KendoChartFullScreenDialog.vue?vue&type=template&id=0b5ba66c"
import script from "./KendoChartFullScreenDialog.vue?vue&type=script&lang=ts"
export * from "./KendoChartFullScreenDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports